import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import MaskedInput from 'react-text-mask';

const TextMaskCustom = ({
    mask,
    showMask,
    guide,
    keepCharPositions,
}) => {
    return props => {
        const { inputRef, ...other } = props;

        return (
            <MaskedInput
                ref={ref => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={mask}
                showMask={showMask}
                guide={guide}
                keepCharPositions={keepCharPositions}
                {...other}
            />
        );
    };
};

const MaskedTextField = ({
    MaskProps,
    InputProps,
    ...others
}) => {
    const [input, setInput] = useState({...InputProps});

    useEffect(() => {
        setInput({
            inputComponent: TextMaskCustom(MaskProps),
            ...InputProps
        });
    }, [MaskProps]);

    return (
        <TextField
            InputProps={input}
            {...others}
        />
    );
};

MaskedTextField.propTypes = {
    MaskProps:  PropTypes.object.isRequired,
    InputProps: PropTypes.object
};

export default MaskedTextField;
